angular = require('angular')
class UserFactory
  @$injector: ['RestfulResource', '$http', '$cookies', '$state', 'config']
  constructor: (RestfulResource, $http, $cookies, $state, config)->
    url = "#{config.api.url}/users"
    actions =
      profile:
       method: "GET"
       url: "#{url}/me"
    User = new RestfulResource("#{url}/:id", {id: "@id"}, actions)
    User.prototype.$login = ()->
      url = "#{config.api.url}/common/login"
      $http.post url, @
        .then (result)=>
          {data:{token}} = result
          options = {}
          if @rememberMe
            now = new Date()
            exp = new Date now.getFullYear() + 1, now.getMonth(), now.getDate()
            options.expires = exp
          $cookies.put 'token', token, options
          console.log token
    User.logout = ()->
      url = "#{config.api.url}/common/logout"
      $cookies.remove('token')
      $http.post(url).then =>
        $state.go "login"
      .catch =>
        $state.go "login"



    return User
module.exports = UserFactory




// WEBPACK FOOTER //
// ./src/component/user/user.coffee